export default "__VITE_ASSET__0ba94e64__"